import React, { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useFormContext } from 'react-hook-form';
import useValidation from 'conversie-flow-bundle/assets/js/components/flow/hooks/useValidation';

export default function ConversionFieldChoiceSalesforce(props) {
    const { colClassName, formGroupClassName = '', customControlClassName = '', field, path, id, updateValue } = props;
    const { type, label, required, disabled, value, name } = field;

    const form = useFormContext();
    const {
        setValue = () => { },
        trigger = () => { },
    } = form || {};

    const { error } = useValidation({ path, ...field, ...form });

    useEffect(() => {
        setValue(path, value);
    }, [value]);

    return (
        <div className={`${colClassName}`}>
            <Form.Group controlId={id} className={`form-group--flow form-group--flow-field-${type} form-group--flow-${name} ${formGroupClassName}`}>
                <Form.Check
                    className={`custom-control custom-checkbox ${customControlClassName} ${error ? 'is-error' : ''}`}
                    type="checkbox"
                    id={id}
                >
                    <Form.Check.Input
                        type="checkbox"
                        className="custom-control-input"
                        name={id}
                        {...{
                            required,
                            disabled,
                        }}
                        checked={Boolean(value)}
                        onChange={(e) => {
                            updateValue(e.target.checked, () => {
                                trigger(path);
                            });
                        }}
                    />
                    <Form.Check.Label className="custom-control-label">
                        {label}
                    </Form.Check.Label>
                </Form.Check>

                {error && (
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                )}
            </Form.Group>
        </div>
    );
}
